import { Api } from "./schema/api";


export const apiClient = new Api({baseUrl: process.env.REACT_APP_ADMORTGAGE_API_URL});